import { useMemo } from 'react';
import type { TaskBodyProps } from '../index';
import { useDxReportDrafts } from '../../../../hooks/useDxReportDrafts';
import { useFinalReviewHandBack } from '../design-dx/useFinalReviewHandBack';
import { FinalReviewDxReport } from './FinalReviewDxReport';
import { FinalReviewFooter } from './FinalReviewFooter';
import { PastFeedback, PastFeedbackTabLabel } from './PastFeedback';
import { ReviewNotesPanel } from './ReviewNotesPanel';

// Init-7 and Redesign-5: the reviewer validates the design and Dx together;
// approving or handing back are the only exits.
export function FinalReviewTask({
    workCase: c,
    statusMeta,
    onPayloadChange,
    onTaskComplete
}: TaskBodyProps) {
    // Only the orthodontist's feedback is still active here; it shows what Clinical had to address.
    const handBack = useFinalReviewHandBack(c.id);
    const { drafts, isLoading: draftsLoading } = useDxReportDrafts(c.id, {
        refetchOnMount: 'always'
    });
    const draft = useMemo(
        () =>
            drafts
                .filter((d) => d.status === 'draft' || d.status === 'pending_review')
                .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))[0] ?? null,
        [drafts]
    );

    return (
        <ReviewNotesPanel
            patientId={c.id}
            macro={statusMeta.macro}
            onPayloadChange={onPayloadChange}
            handBack={handBack}
            dxReport={(addNote) => (
                <FinalReviewDxReport
                    patientId={c.id}
                    draft={draft}
                    draftsLoading={draftsLoading}
                    addNote={addNote}
                />
            )}
            extraTabs={[
                {
                    key: 'past-feedback',
                    label: <PastFeedbackTabLabel patientId={c.id} />,
                    content: <PastFeedback patientId={c.id} />
                }
            ]}
            footer={(notes) => (
                <FinalReviewFooter
                    caseId={c.id}
                    statusMeta={statusMeta}
                    onTaskComplete={onTaskComplete}
                    draft={draft}
                    notes={notes}
                />
            )}
        />
    );
}
